import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Tooltip,
  Row,
  CardImg,
  Label,
} from 'reactstrap';

import ImageGallery from '../../../propinfo/gallery/index';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import timeZoneList from '../../../../../../data/timeZoneList';
import { channel } from 'redux-saga';
const Weekdays = [
  { value: 'Monday', name: 'Monday' },
  { value: 'Tuesday', name: 'Tuesday' },
  { value: 'Wednesday', name: 'Wednesday' },
  { value: 'Thursday', name: 'Thursday' },
  { value: 'Friday', name: 'Friday' },
  { value: 'Saturday', name: 'Saturday' },
  { value: 'Sunday', name: 'Sunday' },
  { value: 'Weekends', name: 'Weekends' },
  { value: 'Weekdays', name: 'Weekdays' },
];
const timeList = [
  { value: '0', name: '0:00' },
  { value: '1', name: '1:00' },
  { value: 2, name: '2:00' },
  { value: '3', name: '3:00' },
  { value: '4', name: '4:00' },
  { value: '5', name: '5:00' },
  { value: '6', name: '6:00' },
  { value: '7', name: '7:00' },
  { value: '8', name: '8:00' },
  { value: '9', name: '9:00' },
  { value: '10', name: '10:00' },
  { value: '11', name: '11:00' },
  { value: '12', name: '12:00' },
  { value: '13', name: '13:00' },
  { value: '14', name: '14:00' },
  { value: '15', name: '15:00' },
  { value: '16', name: '16:00' },
  { value: '17', name: '17:00' },
  { value: '18', name: '18:00' },
  { value: '19', name: '19:00' },
  { value: '29', name: '20:00' },
  { value: '21', name: '21:00' },
  { value: '22', name: '22:00' },
  { value: '23', name: '23:00' },
];
export default function AutoReplies({
  integration,
  propertyData,
  integrationProperties,
  allProperties,
  channelDetails,
  saveIntegration,
}) {
  const [galleryVisible, setGalleryVisible] = useState(false);
  const [formatedProperties, setFormatedProperties] = useState([]);
  const [isEditing, setIsEditing] = useState(false);
  const [list, setList] = useState([]);
  const [name, setName] = useState('');
  const [timeZone, setTimeZone] = useState([]);
  const [propertyList, setPropertyList] = useState([]);
  const createUUID = () => {
    const pattern = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx';
    return pattern.replace(/[xy]/g, (c) => {
      const r = (Math.random() * 16) | 0;
      const v = c === 'x' ? r : (r & 0x3) | 0x8;
      return v.toString(16);
    });
  };
  const [autoRepliesSetting, setAutoRepliesSetting] = useState(
    channelDetails?.autoReplies || {
      enabled: false,
      displayRules: '3',
      businessHours: {
        timeZone: propertyData.timeZone,
        time: [
          {
            id: 1,
            hourFrom: '0',
            hourTo: '1',
            day: '',
          },
        ],
      },
    }
  );
  useEffect(() => {
    let val = [];
    timeZoneList.map((m, index) => m.TimeZones.map((t) => val.push(t)));
    val = val.sort((a, b) => a.localeCompare(b));
    setTimeZone(val);
  }, [allProperties]);

  const togglegallery = () => {
    setGalleryVisible(!galleryVisible);
  };

  const handleSave = () => {
    channelDetails.autoReplies = autoRepliesSetting;
    saveIntegration({ channelDetails });
  };

  const handleAutoRepliesEnabled = (e) =>
    setAutoRepliesSetting({ ...autoRepliesSetting, enabled: e });

  const handleTimeZone = (event) => {
    let lst = autoRepliesSetting.businessHours;

    lst.timeZone = event.target.value;
    setAutoRepliesSetting({ ...autoRepliesSetting, businessHours: lst });
  };

  const handleBusinessHours = (type, value, id) => {
    let businessHours = autoRepliesSetting.businessHours;
    let time = businessHours.time.filter((f) => f.id === id);
    if (
      autoRepliesSetting.businessHours.time.filter((f) => f.id === id).length >
      0
    ) {
      switch (type) {
        case 'hourFrom':
          businessHours.time.map((f) => {
            if (f.id === id) f.hourFrom = value;
            return f;
          });

          setAutoRepliesSetting({
            ...autoRepliesSetting,
            businessHours: businessHours,
          });
          break;

        case 'hourTo':
          businessHours.time.map((f) => {
            if (f.id === id) f.hourTo = value;
            return f;
          });

          setAutoRepliesSetting({
            ...autoRepliesSetting,
            businessHours: businessHours,
          });
          break;

        case 'day':
          businessHours.time.map((f) => {
            if (f.id === id) f.day = value;
            return f;
          });

          setAutoRepliesSetting({
            ...autoRepliesSetting,
            businessHours: businessHours,
          });
          break;
      }
    }
  };
  const AddBusinessHours = () => {
    let lst = autoRepliesSetting.businessHours;
    lst.time.push({
      id: createUUID(),
      hourFrom: '0',
      hourTo: '1',
      day: Weekdays.filter((f) =>
        autoRepliesSetting.businessHours.time.filter((l) => l.day === f.value)
      )[0],
    });
    setAutoRepliesSetting({ ...autoRepliesSetting, businessHours: lst });
  };

  const RemoveBusinessHours = (id) => {
    let lst = autoRepliesSetting.businessHours;
    lst.time = lst.time.filter((f) => f.id !== id);

    setAutoRepliesSetting({ ...autoRepliesSetting, businessHours: lst });
  };
  const handleBack = () => {
    setAutoRepliesSetting(
      channelDetails?.autoReplies || {
        enabled: false,
        displayRules: '3',
        outSideIndicator: false,
        businessHours: {
          timeZone: propertyData.timeZone,
          time: [
            {
              id: 1,
              hourFrom: '0',
              hourTo: '1',
              day: '',
            },
          ],
        },
        provider: 0,
        zendesk: { accountKey: '', department: '', departmentId: '' },
        genesysPureCloudSettings: {
          openMessageIntegrationId: '',
          appUserName: '',
          appPassword: '',
        },
      }
    );
  };
  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Auto-replies</h6>
          </div>
          <Separator className="mb-3" />
          <div className="row mt-1 ml-2 mb-3">
            <Colxx md="12" className="mb-2">
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small ml-2 float-right"
                checked={autoRepliesSetting?.enabled}
                name="enabled"
                onChange={(e) => handleAutoRepliesEnabled(e)}
              />
            </Colxx>
            <Colxx md="12">
              <div className="row mt-2">
                <h5>Auto-reply Timing</h5>
              </div>
              <div className="row">
                Select when you want to auto reply to emails.
              </div>
              <div className="ml-2">
                <div className="row mt-1">
                  <div className="mt-1 ml-1">
                    <CustomInput
                      type="radio"
                      name="displayRules"
                      checked={
                        autoRepliesSetting.displayRules === 'Allways'
                          ? true
                          : false
                      }
                      onChange={(event) => {
                        setAutoRepliesSetting({
                          ...autoRepliesSetting,
                          displayRules: 'Allways',
                        });
                      }}
                    >
                      Always visible
                    </CustomInput>
                  </div>
                </div>

                <div className="row mt-1 mb-2">
                  <div className=" d-flex mt-1 ml-1">
                    <CustomInput
                      type="radio"
                      name="displayRules"
                      checked={
                        autoRepliesSetting.displayRules === 'BusinessHours'
                          ? true
                          : false
                      }
                      onChange={(event) => {
                        setAutoRepliesSetting({
                          ...autoRepliesSetting,
                          displayRules: 'BusinessHours',
                        });
                      }}
                    >
                      Set auto reply hours
                    </CustomInput>
                  </div>
                </div>
                <div className="row mt-1 mb-2">
                  {autoRepliesSetting.displayRules === 'BusinessHours' && (
                    <Fragment>
                      <div className="row mt-2">
                        <Colxx xxs="12" className="mb-2 ">
                          <Label>Time Zone </Label>
                          <Input
                            type="select"
                            className="ml-3 pl-2 dropdown-menu dropdowntimezone"
                            name="type"
                            value={autoRepliesSetting.businessHours?.timeZone}
                            onChange={handleTimeZone}
                          >
                            {timeZone.length > 0 &&
                              timeZone.map((t) => (
                                <option
                                  className="dropdown-item"
                                  key={t}
                                  value={t}
                                >
                                  {t}
                                </option>
                              ))}
                          </Input>
                        </Colxx>
                      </div>
                      {autoRepliesSetting.businessHours?.time.length > 0 &&
                        autoRepliesSetting.businessHours.time.map(
                          (m, index) => (
                            <div
                              key={m.id}
                              className="d-flex ml-0 col-md-12  mt-2"
                            >
                              <Input
                                type="select"
                                value={m.day}
                                name="type"
                                onChange={(e) =>
                                  handleBusinessHours(
                                    'day',
                                    e.target.value,
                                    m.id
                                  )
                                }
                              >
                                <option value="0">Please Select</option>
                                {Weekdays.length > 0 &&
                                  Weekdays.map((w, index) => {
                                    if (
                                      autoRepliesSetting.businessHours.time.filter(
                                        (f) =>
                                          f.day === w.value && f.id !== m.id
                                      ).length == 0
                                    )
                                      return (
                                        <option key={w.value} value={w.value}>
                                          {w.name}
                                        </option>
                                      );
                                  })}
                              </Input>
                              <Input
                                type="select"
                                className="ml-2"
                                value={m.hourFrom}
                                name="type"
                                onChange={(e) =>
                                  handleBusinessHours(
                                    'hourFrom',
                                    e.target.value,
                                    m.id
                                  )
                                }
                              >
                                {timeList.length > 0 &&
                                  timeList.map((m, index) => (
                                    <option key={m.value} value={m.value}>
                                      {m.name}
                                    </option>
                                  ))}
                              </Input>
                              <span className="ml-2 mt-2 ">to</span>
                              <Input
                                type="select"
                                className="ml-2"
                                value={m.hourTo}
                                name="type"
                                onChange={(e) =>
                                  handleBusinessHours(
                                    'hourTo',
                                    e.target.value,
                                    m.id
                                  )
                                }
                              >
                                {timeList.length > 0 &&
                                  timeList.map((m, index) => (
                                    <option key={m.value} value={m.value}>
                                      {m.name}
                                    </option>
                                  ))}
                              </Input>
                              <Button
                                color="danger"
                                size="xs"
                                className="ml-2"
                                outline
                                onClick={() => {
                                  RemoveBusinessHours(m.id);
                                }}
                              >
                                -
                              </Button>
                            </div>
                          )
                        )}
                      <div className="row col-md-12 mt-3">
                        <Button
                          color="primary"
                          outline
                          size="xs"
                          onClick={AddBusinessHours}
                        >
                          Add hours
                        </Button>
                      </div>
                    </Fragment>
                  )}
                </div>
              </div>
            </Colxx>
          </div>
          <Separator className="mb-2" />
          <Colxx md="12" className="text-center mb-2">
            <Button
              onClick={() => handleSave()}
              color="primary"
              size="xs"
              outline
            >
              Save
            </Button>
            <Button
              className="ml-2"
              onClick={() => handleBack()}
              color="secondary"
              size="xs"
              outline
            >
              Cancel
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
